import { Listable } from 'data/types';
import Image from 'next/legacy/image';

type Props = {
  listable: Listable;
  className?: string;
  alt?: string;
};

export default function ListableImage({ listable, className, alt }: Props) {
  const defaultWidth = 400;
  const defaultHeight = 400;

  const imageWidth = listable.imageWidth ?? defaultWidth;
  const imageHeight = listable.imageHeight ?? defaultHeight;

  const aspectRatio = imageWidth / imageHeight;
  const maxHeight = 200;
  const maxWidth = maxHeight * aspectRatio;

  return (
    <>
      {listable.webpPath && listable.webpPath !== 'null' && (
        <div
          className={`${className} max-h-[300px] flex justify-center items-center`}
        >
          <Image
            src={listable.webpPath}
            width={maxWidth}
            height={maxHeight}
            alt={alt || listable.name}
            loading="lazy"
          />
        </div>
      )}
    </>
  );
}
